// Fragment "pages1 (lot H)" — rempli par son lot de retrofit ; fusionné dans ./index.js.
// Convention : clés plates pointées, valeurs dans les 3 langues, jamais vides.
export default {
  fr: {
    // Programmes.jsx
    "programs.eyebrow": "Programmes & forfaits",
    "programs.heading": "Allez plus loin, ensemble.",
    "programs.subheading": "Des parcours d'accompagnement complets pour transformer votre santé en profondeur — bien au-delà d'une consultation ponctuelle.",
    "programs.empty": "Les programmes sont en préparation. Revenez bientôt.",
    "programs.toast.error": "Erreur",
    "programs.featured": "Recommandé",
    "programs.durationFallback": "Programme",
    "programs.investment": "Investissement",
    "programs.cta": "S'inscrire",

    // Codes d'erreur de paiement (partagés par Programmes.jsx et Boutique.jsx).
    // Le backend renvoie {code, message} : le CODE est stable et machine-lisible,
    // le `message` est un diagnostic développeur — jamais ce que l'acheteur lit.
    "checkout.error.invalidProduct": "Ce produit est incomplet et ne peut pas être vendu pour l'instant. Contactez-nous.",
    "checkout.error.invalidProgram": "Ce programme est incomplet et ne peut pas être vendu pour l'instant. Contactez-nous.",
    "checkout.error.invalidPrice": "Ce tarif n'est pas payable en ligne. Contactez-nous pour finaliser.",
    "checkout.error.providerUnavailable": "Le service de paiement est momentanément indisponible. Réessayez dans quelques minutes.",
    // BUG-042 — refus d'une carte-cadeau au moment du paiement (déjà utilisée, annulée
    // ou solde insuffisant depuis l'aperçu).
    "checkout.error.giftcardDeclined": "Cette carte-cadeau ne peut pas être utilisée pour cet achat. Vérifiez le code ou essayez un autre moyen de paiement.",
    "checkout.error.currencyNotSettleable": "Ce tarif est dans une devise que ce site ne peut plus encaisser en ligne. Contactez-nous pour finaliser votre achat.",

    // Boutique.jsx
    "shop.eyebrow": "Boutique",
    "shop.heading": "Produits & ressources.",
    "shop.subheading": "Une sélection de produits et de ressources que j'utilise et recommande.",
    "shop.giftButton": "Offrir une carte-cadeau",
    "shop.empty": "La boutique est en préparation.",
    "shop.toast.error": "Erreur",
    "shop.productType.affiliate": "Recommandation",
    "shop.productType.own": "Boutique",
    "shop.viaPartner": "via partenaire",
    "shop.viewProduct": "Voir le produit",
    "shop.buy": "Acheter",
    "shop.giftcard.title": "Carte-cadeau 🌿",
    "shop.giftcard.subtitle": "Offrez une consultation, un produit, ou une part d'accompagnement.",
    "shop.giftcard.amount": "Montant",
    "shop.giftcard.customAmountPh": "Autre $",
    "shop.giftcard.recipientEmailPh": "Courriel du destinataire",
    "shop.giftcard.recipientNamePh": "Nom du destinataire (optionnel)",
    "shop.giftcard.messagePh": "Petit mot (optionnel)",
    "shop.giftcard.toast.error": "Erreur",
    "shop.giftcard.submit": "Payer & envoyer",

    // ClientPortal.jsx
    "portal.title": "Mon espace",
    "portal.subtitle": "Retrouvez vos rendez-vous, vos cours et vos consultations.",
    "portal.signinPrompt": "Connectez-vous pour accéder à votre espace personnel.",
    "portal.signin": "Continuer avec Google",
    "portal.authErrExpired": "Le lien de connexion a expiré. Réessayez.",
    "portal.authErrInvalid": "Connexion impossible. Réessayez.",
    "portal.logout": "Se déconnecter",
    "portal.bookings": "Mes rendez-vous",
    "portal.courses": "Mes cours",
    "portal.consults": "Mes consultations vidéo",
    "portal.noBookings": "Aucun rendez-vous pour le moment.",
    "portal.noCourses": "Vous n'êtes inscrit·e à aucun cours.",
    "portal.noConsults": "Aucune consultation vidéo programmée.",
    "portal.bookNow": "Réserver un rendez-vous",
    "portal.browseCourses": "Découvrir les cours",
    "portal.continue": "Continuer",
    "portal.join": "Rejoindre",
    "portal.lessonsDone": "leçon(s) complétée(s)",
    "portal.courseFallback": "Cours",
    "portal.consultationFallback": "Consultation",
    "portal.status.pending": "En attente",
    "portal.status.pending_payment": "Paiement en attente",
    "portal.status.paid_needs_attention": "Paiement reçu — confirmation en cours",
    "portal.status.confirmed": "Confirmé",
    "portal.status.cancelled": "Annulé",
    "portal.status.scheduled": "Programmée",
    "portal.status.active": "En cours",
    "portal.status.completed": "Terminée",

    // THE CONSULTATION'S OWN STATE (F-25), on the "My video consultations" rows. A
    // SEPARATE family from `portal.status.*` above, because it renders a different
    // vocabulary: those are BOOKING statuses, these are `schemas.SESSION_STATES`, and the
    // portal used to render the frozen `video_rooms.status` — the literal "scheduled"
    // written once at provisioning — for both. A consultation that had been held, billed
    // and receipted read "Programmée" beside its own receipt.
    // `keyCoverage.test.js` pins this family against the Python tuple.
    "portal.consultStatus.scheduled": "Programmée",
    "portal.consultStatus.in_progress": "En cours",
    "portal.consultStatus.computing": "Calcul du montant",
    "portal.consultStatus.computed": "Montant calculé",
    "portal.consultStatus.captured": "Terminée et facturée",
    "portal.consultStatus.void_no_show": "Absence — non facturée",
    "portal.consultStatus.cancelled": "Annulée",

    // Reserver.jsx
    "booking.eyebrow": "Réservation en ligne",
    "booking.heading": "Choisissez votre moment.",
    "booking.subheading": "Sélectionnez un créneau disponible et remplissez vos informations.",
    "booking.nextStepPaid": "Le paiement confirme votre rendez-vous immédiatement : la confirmation et l'invitation calendrier vous parviennent dès qu'il est accepté.",
    "booking.nextStepFree": "Vous recevrez un accusé de réception, puis la confirmation finale — avec l'invitation calendrier — une fois votre demande approuvée.",
    "booking.confirmTitle": "Merci {name} 🌿",
    "booking.confirmBody": "Votre demande est enregistrée — un accusé de réception vient de vous être envoyé par courriel. Dès qu'elle sera approuvée, vous recevrez la confirmation finale avec l'invitation calendrier.",
    "booking.minutesSuffix": "min",
    "booking.videoBadge": "Visioconsultation",
    "booking.backHome": "Retour à l'accueil",
    "booking.noSlots": "Aucun créneau ouvert pour l'instant. Revenez bientôt ou écrivez-nous.",
    "booking.noBookableService": "Aucun service n'est réservable en ligne pour le moment. Écrivez-nous directement.",
    "booking.yourInfo": "Vos informations",
    "booking.firstNamePh": "Prénom",
    "booking.lastNamePh": "Nom",
    "booking.emailPh": "Courriel",
    "booking.phonePh": "Téléphone (optionnel)",
    "booking.notesPh": "Notes (optionnel)",
    "booking.validation.firstNameRequired": "Le prénom est requis.",
    "booking.validation.firstNameTooLong": "Le prénom est trop long (80 caractères maximum).",
    "booking.validation.lastNameRequired": "Le nom est requis.",
    "booking.validation.lastNameTooLong": "Le nom est trop long (80 caractères maximum).",
    "booking.validation.emailRequired": "Le courriel est requis.",
    "booking.validation.emailInvalid": "Entrez une adresse courriel valide.",
    "booking.validation.phoneTooLong": "Le numéro de téléphone est trop long (40 caractères maximum).",
    "booking.validation.notesTooLong": "Les notes sont trop longues (2000 caractères maximum).",
    "booking.payButton": "Payer et réserver",
    "booking.serviceUnavailable": "Ce service n'est plus disponible. Choisissez-en un autre.",
    "booking.confirmButton": "Confirmer la demande",
    "booking.genericError": "Erreur",
    "booking.invalidDetails": "Vérifiez les informations saisies, puis réessayez.",
    "booking.rateLimited": "Trop de tentatives en peu de temps. Patientez une minute, puis réessayez.",
    "booking.practiceUnavailable": "Ce cabinet ne prend pas de rendez-vous en ligne pour le moment. Écrivez-nous directement.",
    "booking.pickDate": "Choisissez une date",
    "booking.timesFor": "Créneaux du {date}",
    "booking.timezoneNote": "Heures affichées selon votre fuseau horaire : {tz}",
    "booking.noTimes": "Aucun horaire disponible pour cette date.",
    "booking.chooseService": "Quel service souhaitez-vous réserver ?",
    "booking.chooseServiceHelp": "Choisissez un service pour ne voir que ses disponibilités.",
    "booking.freeLabel": "Gratuit",
    "booking.changeService": "Changer de service",
    "booking.serviceFallback": "Consultation",
    "booking.alreadyBooked": "Vous avez déjà une réservation pour ce créneau.",
    "booking.alreadyPaid": "Ce rendez-vous est déjà payé. Votre confirmation arrive par courriel dans un instant.",
    "booking.holdExpired": "Votre paiement a expiré et la place est en cours de libération. Réessayez dans quelques minutes.",
    "booking.resumeTitle": "Un paiement est en cours",
    "booking.resumeBody": "Votre place pour {service} est retenue le temps de régler. Reprenez là où vous en étiez.",
    "booking.resumePay": "Reprendre le paiement",
    "booking.resumeDismiss": "Abandonner",
  },
  en: {
    // Programmes.jsx
    "programs.eyebrow": "Programs & packages",
    "programs.heading": "Go further, together.",
    "programs.subheading": "Complete guided pathways to transform your health in depth — well beyond a one-off consultation.",
    "programs.empty": "Programs are being prepared. Check back soon.",
    "programs.toast.error": "Error",
    "programs.featured": "Recommended",
    "programs.durationFallback": "Program",
    "programs.investment": "Investment",
    "programs.cta": "Enroll",

    "checkout.error.invalidProduct": "This product is incomplete and cannot be sold right now. Please get in touch.",
    "checkout.error.invalidProgram": "This program is incomplete and cannot be sold right now. Please get in touch.",
    "checkout.error.invalidPrice": "This price cannot be paid online. Please get in touch to complete your purchase.",
    "checkout.error.providerUnavailable": "The payment service is temporarily unavailable. Please try again in a few minutes.",
    "checkout.error.giftcardDeclined": "This gift card can't be used for this purchase. Check the code or try another payment method.",
    "checkout.error.currencyNotSettleable": "This price is in a currency this site can no longer charge online. Please get in touch to complete your purchase.",

    // Boutique.jsx
    "shop.eyebrow": "Shop",
    "shop.heading": "Products & resources.",
    "shop.subheading": "A selection of products and resources I use and recommend.",
    "shop.giftButton": "Give a gift card",
    "shop.empty": "The shop is being prepared.",
    "shop.toast.error": "Error",
    "shop.productType.affiliate": "Recommendation",
    "shop.productType.own": "Shop",
    "shop.viaPartner": "via partner",
    "shop.viewProduct": "View product",
    "shop.buy": "Buy",
    "shop.giftcard.title": "Gift card 🌿",
    "shop.giftcard.subtitle": "Give a consultation, a product, or a portion of guided support.",
    "shop.giftcard.amount": "Amount",
    "shop.giftcard.customAmountPh": "Other $",
    "shop.giftcard.recipientEmailPh": "Recipient's email",
    "shop.giftcard.recipientNamePh": "Recipient's name (optional)",
    "shop.giftcard.messagePh": "Short message (optional)",
    "shop.giftcard.toast.error": "Error",
    "shop.giftcard.submit": "Pay & send",

    // ClientPortal.jsx
    "portal.title": "My account",
    "portal.subtitle": "Find your appointments, courses and consultations.",
    "portal.signinPrompt": "Sign in to access your personal space.",
    "portal.signin": "Continue with Google",
    "portal.authErrExpired": "The sign-in link expired. Please try again.",
    "portal.authErrInvalid": "Sign-in failed. Please try again.",
    "portal.logout": "Sign out",
    "portal.bookings": "My appointments",
    "portal.courses": "My courses",
    "portal.consults": "My video consultations",
    "portal.noBookings": "No appointments yet.",
    "portal.noCourses": "You are not enrolled in any course.",
    "portal.noConsults": "No video consultation scheduled.",
    "portal.bookNow": "Book an appointment",
    "portal.browseCourses": "Browse courses",
    "portal.continue": "Continue",
    "portal.join": "Join",
    "portal.lessonsDone": "lesson(s) completed",
    "portal.courseFallback": "Course",
    "portal.consultationFallback": "Consultation",
    "portal.status.pending": "Pending",
    "portal.status.pending_payment": "Awaiting payment",
    "portal.status.paid_needs_attention": "Paid — confirmation in progress",
    "portal.status.confirmed": "Confirmed",
    "portal.status.cancelled": "Cancelled",
    "portal.status.scheduled": "Scheduled",
    "portal.status.active": "Live",
    "portal.status.completed": "Completed",

    "portal.consultStatus.scheduled": "Scheduled",
    "portal.consultStatus.in_progress": "In progress",
    "portal.consultStatus.computing": "Working out the amount",
    "portal.consultStatus.computed": "Amount worked out",
    "portal.consultStatus.captured": "Completed and billed",
    "portal.consultStatus.void_no_show": "No-show — not billed",
    "portal.consultStatus.cancelled": "Cancelled",

    // Reserver.jsx
    "booking.eyebrow": "Online booking",
    "booking.heading": "Choose your moment.",
    "booking.subheading": "Select an available slot and fill in your details.",
    "booking.nextStepPaid": "Payment confirms your appointment straight away: the confirmation and the calendar invitation reach you as soon as it goes through.",
    "booking.nextStepFree": "You'll get an acknowledgement, then the final confirmation — with the calendar invitation — once your request is approved.",
    "booking.confirmTitle": "Thank you {name} 🌿",
    "booking.confirmBody": "Your request has been received — an acknowledgement email is on its way. As soon as it is approved, you'll get the final confirmation with the calendar invitation.",
    "booking.minutesSuffix": "min",
    "booking.videoBadge": "Video consultation",
    "booking.backHome": "Back to home",
    "booking.noSlots": "No open slots right now. Check back soon or send us a message.",
    "booking.noBookableService": "No service is bookable online right now. Please write to us directly.",
    "booking.yourInfo": "Your details",
    "booking.firstNamePh": "First name",
    "booking.lastNamePh": "Last name",
    "booking.emailPh": "Email",
    "booking.phonePh": "Phone (optional)",
    "booking.notesPh": "Notes (optional)",
    "booking.validation.firstNameRequired": "First name is required.",
    "booking.validation.firstNameTooLong": "First name is too long (80 characters max).",
    "booking.validation.lastNameRequired": "Last name is required.",
    "booking.validation.lastNameTooLong": "Last name is too long (80 characters max).",
    "booking.validation.emailRequired": "Email is required.",
    "booking.validation.emailInvalid": "Enter a valid email address.",
    "booking.validation.phoneTooLong": "Phone number is too long (40 characters max).",
    "booking.validation.notesTooLong": "Notes are too long (2000 characters max).",
    "booking.payButton": "Pay and book",
    "booking.serviceUnavailable": "This service is no longer available. Please choose another one.",
    "booking.confirmButton": "Confirm request",
    "booking.genericError": "Error",
    "booking.invalidDetails": "Please check the details you entered, then try again.",
    "booking.rateLimited": "Too many attempts in a short time. Please wait a minute and try again.",
    "booking.practiceUnavailable": "This practice is not taking online bookings right now. Please write to us directly.",
    "booking.pickDate": "Pick a date",
    "booking.timesFor": "Times for {date}",
    "booking.timezoneNote": "Times shown in your time zone: {tz}",
    "booking.noTimes": "No times available for this date.",
    "booking.chooseService": "Which service would you like to book?",
    "booking.chooseServiceHelp": "Pick a service to see only its available times.",
    "booking.freeLabel": "Free",
    "booking.changeService": "Change service",
    "booking.serviceFallback": "Consultation",
    "booking.alreadyBooked": "You already have a booking for this time slot.",
    "booking.alreadyPaid": "This appointment is already paid for. Your confirmation email is on its way.",
    "booking.holdExpired": "Your payment expired and the slot is being released. Please try again in a few minutes.",
    "booking.resumeTitle": "A payment is in progress",
    "booking.resumeBody": "Your place for {service} is held while you pay. Pick up where you left off.",
    "booking.resumePay": "Resume payment",
    "booking.resumeDismiss": "Discard",
  },
  es: {
    // Programmes.jsx
    "programs.eyebrow": "Programas y paquetes",
    "programs.heading": "Ve más lejos, juntos.",
    "programs.subheading": "Itinerarios de acompañamiento completos para transformar tu salud en profundidad — mucho más allá de una consulta puntual.",
    "programs.empty": "Los programas están en preparación. Vuelve pronto.",
    "programs.toast.error": "Error",
    "programs.featured": "Recomendado",
    "programs.durationFallback": "Programa",
    "programs.investment": "Inversión",
    "programs.cta": "Inscribirme",

    "checkout.error.invalidProduct": "Este producto está incompleto y no se puede vender por ahora. Contáctanos.",
    "checkout.error.invalidProgram": "Este programa está incompleto y no se puede vender por ahora. Contáctanos.",
    "checkout.error.invalidPrice": "Este precio no se puede pagar en línea. Contáctanos para completar la compra.",
    "checkout.error.providerUnavailable": "El servicio de pago no está disponible momentáneamente. Inténtalo de nuevo en unos minutos.",
    "checkout.error.giftcardDeclined": "Esta tarjeta regalo no se puede usar para esta compra. Verifica el código o intenta otro método de pago.",
    "checkout.error.currencyNotSettleable": "Este precio está en una moneda que este sitio ya no puede cobrar en línea. Contáctanos para completar la compra.",

    // Boutique.jsx
    "shop.eyebrow": "Tienda",
    "shop.heading": "Productos y recursos.",
    "shop.subheading": "Una selección de productos y recursos que uso y recomiendo.",
    "shop.giftButton": "Regalar una tarjeta de regalo",
    "shop.empty": "La tienda está en preparación.",
    "shop.toast.error": "Error",
    "shop.productType.affiliate": "Recomendación",
    "shop.productType.own": "Tienda",
    "shop.viaPartner": "a través de un socio",
    "shop.viewProduct": "Ver producto",
    "shop.buy": "Comprar",
    "shop.giftcard.title": "Tarjeta de regalo 🌿",
    "shop.giftcard.subtitle": "Regala una consulta, un producto o una parte de acompañamiento.",
    "shop.giftcard.amount": "Monto",
    "shop.giftcard.customAmountPh": "Otro $",
    "shop.giftcard.recipientEmailPh": "Correo del destinatario",
    "shop.giftcard.recipientNamePh": "Nombre del destinatario (opcional)",
    "shop.giftcard.messagePh": "Mensaje breve (opcional)",
    "shop.giftcard.toast.error": "Error",
    "shop.giftcard.submit": "Pagar y enviar",

    // ClientPortal.jsx
    "portal.title": "Mi espacio",
    "portal.subtitle": "Encuentra tus citas, cursos y consultas.",
    "portal.signinPrompt": "Inicia sesión para acceder a tu espacio personal.",
    "portal.signin": "Continuar con Google",
    "portal.authErrExpired": "El enlace de acceso caducó. Inténtalo de nuevo.",
    "portal.authErrInvalid": "No se pudo iniciar sesión. Inténtalo de nuevo.",
    "portal.logout": "Cerrar sesión",
    "portal.bookings": "Mis citas",
    "portal.courses": "Mis cursos",
    "portal.consults": "Mis videoconsultas",
    "portal.noBookings": "Aún no hay citas.",
    "portal.noCourses": "No estás inscrito en ningún curso.",
    "portal.noConsults": "No hay videoconsulta programada.",
    "portal.bookNow": "Reservar una cita",
    "portal.browseCourses": "Ver los cursos",
    "portal.continue": "Continuar",
    "portal.join": "Unirse",
    "portal.lessonsDone": "lección(es) completada(s)",
    "portal.courseFallback": "Curso",
    "portal.consultationFallback": "Consulta",
    "portal.status.pending": "Pendiente",
    "portal.status.pending_payment": "Pago pendiente",
    "portal.status.paid_needs_attention": "Pagado — confirmación en curso",
    "portal.status.confirmed": "Confirmada",
    "portal.status.cancelled": "Cancelada",
    "portal.status.scheduled": "Programada",
    "portal.status.active": "En vivo",
    "portal.status.completed": "Finalizada",

    "portal.consultStatus.scheduled": "Programada",
    "portal.consultStatus.in_progress": "En curso",
    "portal.consultStatus.computing": "Calculando el importe",
    "portal.consultStatus.computed": "Importe calculado",
    "portal.consultStatus.captured": "Finalizada y facturada",
    "portal.consultStatus.void_no_show": "Ausencia — sin cobro",
    "portal.consultStatus.cancelled": "Cancelada",

    // Reserver.jsx
    "booking.eyebrow": "Reserva en línea",
    "booking.heading": "Elige tu momento.",
    "booking.subheading": "Selecciona un horario disponible y completa tus datos.",
    "booking.nextStepPaid": "El pago confirma tu cita de inmediato: recibirás la confirmación y la invitación de calendario en cuanto se acepte.",
    "booking.nextStepFree": "Recibirás un acuse de recibo y luego la confirmación final — con la invitación de calendario — cuando se apruebe tu solicitud.",
    "booking.confirmTitle": "Gracias {name} 🌿",
    "booking.confirmBody": "Tu solicitud fue registrada — acabamos de enviarte un acuse de recibo por correo. En cuanto sea aprobada, recibirás la confirmación final con la invitación de calendario.",
    "booking.minutesSuffix": "min",
    "booking.videoBadge": "Videoconsulta",
    "booking.backHome": "Volver al inicio",
    "booking.noSlots": "No hay horarios disponibles por ahora. Vuelve pronto o escríbenos.",
    "booking.noBookableService": "Ningún servicio se puede reservar en línea por ahora. Escríbenos directamente.",
    "booking.yourInfo": "Tus datos",
    "booking.firstNamePh": "Nombre",
    "booking.lastNamePh": "Apellido",
    "booking.emailPh": "Correo",
    "booking.phonePh": "Teléfono (opcional)",
    "booking.notesPh": "Notas (opcional)",
    "booking.validation.firstNameRequired": "El nombre es obligatorio.",
    "booking.validation.firstNameTooLong": "El nombre es demasiado largo (máximo 80 caracteres).",
    "booking.validation.lastNameRequired": "El apellido es obligatorio.",
    "booking.validation.lastNameTooLong": "El apellido es demasiado largo (máximo 80 caracteres).",
    "booking.validation.emailRequired": "El correo es obligatorio.",
    "booking.validation.emailInvalid": "Introduce un correo electrónico válido.",
    "booking.validation.phoneTooLong": "El teléfono es demasiado largo (máximo 40 caracteres).",
    "booking.validation.notesTooLong": "Las notas son demasiado largas (máximo 2000 caracteres).",
    "booking.payButton": "Pagar y reservar",
    "booking.serviceUnavailable": "Este servicio ya no está disponible. Elige otro.",
    "booking.confirmButton": "Confirmar solicitud",
    "booking.genericError": "Error",
    "booking.invalidDetails": "Revisa los datos que ingresaste e inténtalo de nuevo.",
    "booking.rateLimited": "Demasiados intentos en poco tiempo. Espera un minuto e inténtalo de nuevo.",
    "booking.practiceUnavailable": "Este consultorio no acepta reservas en línea por ahora. Escríbenos directamente.",
    "booking.pickDate": "Elige una fecha",
    "booking.timesFor": "Horarios del {date}",
    "booking.timezoneNote": "Horas mostradas en tu huso horario: {tz}",
    "booking.noTimes": "No hay horarios disponibles para esta fecha.",
    "booking.chooseService": "¿Qué servicio deseas reservar?",
    "booking.chooseServiceHelp": "Elige un servicio para ver solo sus horarios disponibles.",
    "booking.freeLabel": "Gratis",
    "booking.changeService": "Cambiar de servicio",
    "booking.serviceFallback": "Consulta",
    "booking.alreadyBooked": "Ya tienes una reserva para este horario.",
    "booking.alreadyPaid": "Esta cita ya está pagada. Tu correo de confirmación está en camino.",
    "booking.holdExpired": "Tu pago ha caducado y la plaza se está liberando. Inténtalo de nuevo en unos minutos.",
    "booking.resumeTitle": "Hay un pago en curso",
    "booking.resumeBody": "Tu plaza para {service} está reservada mientras pagas. Continúa donde lo dejaste.",
    "booking.resumePay": "Reanudar el pago",
    "booking.resumeDismiss": "Descartar",
  },
};
